module.exports = __webpack_public_path__ + "img/lifeBlock_4_en.aee43109.png";